import React from 'react';
import { JcCommonProps } from '../../utils/JcUtils';
import { JcUtils } from '../../utils/JcUtils';

export interface JcAppFooterProps extends JcCommonProps {
    readonly children: React.ReactNode;
    readonly copyrightText: string;
}

export const JcAppFooter = (props: JcAppFooterProps): React.ReactElement => {
    const { children, copyrightText } = props;
    const commonProps = JcUtils.commonProps(props, ["jc-app-footer"]);
    return <footer {...commonProps}>
        {children}
        <div className="jc-app-copyright">{copyrightText}</div>
    </footer>;
};
